import { Button, Group, Modal, Stack, Text, TextInput } from '@common/ui'
import { useEffect, useState } from 'react'

type SaveAsPolicyDialogProps = {
  open: boolean
  permissionCount: number
  onCancel: () => void
  onConfirm: (name: string) => Promise<void> | void
}

const SaveAsPolicyDialog = ({ open, permissionCount, onCancel, onConfirm }: SaveAsPolicyDialogProps) => {
  const [name, setName] = useState('')
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (open) {
      setName('')
      setSubmitting(false)
    }
  }, [open])

  const trimmed = name.trim()
  const canConfirm = trimmed.length > 0 && permissionCount > 0 && !submitting

  const confirm = async () => {
    setSubmitting(true)
    try {
      await onConfirm(trimmed)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Modal opened={open} onClose={onCancel} title="Save as policy" size="sm">
      <Stack gap="md">
        <Text c="dimmed">
          Save the current set of {permissionCount} permission{permissionCount === 1 ? '' : 's'} as a reusable policy.
        </Text>
        <TextInput
          size="sm"
          label="Policy name"
          value={name}
          onChange={(event) => setName(event.target.value)}
          onKeyDown={async (event) => {
            if (event.key === 'Enter' && canConfirm) await confirm()
          }}
        />
        <Group justify="flex-end">
          <Button variant="default" onClick={onCancel} disabled={submitting}>
            Cancel
          </Button>
          <Button disabled={!canConfirm} onClick={confirm}>
            Save
          </Button>
        </Group>
      </Stack>
    </Modal>
  )
}

export default SaveAsPolicyDialog
